/**
 * @flow
 * @relayHash 255a22c56b51f5ec554811167010060b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Http4xxErrorsTable_project$ref = any;
export type httpStatus_HttpStatusCategory_Http4xxErrorsTable_QueryVariables = {|
  host: string
|};
export type httpStatus_HttpStatusCategory_Http4xxErrorsTable_QueryResponse = {|
  +project: ?{|
    +$fragmentRefs: Http4xxErrorsTable_project$ref
  |}
|};
export type httpStatus_HttpStatusCategory_Http4xxErrorsTable_Query = {|
  variables: httpStatus_HttpStatusCategory_Http4xxErrorsTable_QueryVariables,
  response: httpStatus_HttpStatusCategory_Http4xxErrorsTable_QueryResponse,
|};
*/


/*
query httpStatus_HttpStatusCategory_Http4xxErrorsTable_Query(
  $host: String!
) {
  project(host: $host) {
    ...Http4xxErrorsTable_project
    id
  }
}

fragment Http4xxErrorsTable_project on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        countCodesHttp4xxErrors(linkTypeFilter: {showInternal: true, showExternal: true}, errorUrl: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}) {
          code
          count
        }
        http4xxErrors(offset: 0, limit: 20, codeFilters: [], linkTypeFilter: {showInternal: true, showExternal: true}, errorUrl: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}) {
          count
          edges {
            node {
              ...Http4xxErrorsRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment Http4xxErrorsRow_issue on Http4xxError {
  id
  type
  severity
  code
  internal
  error_url
  source_url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Literal",
  "name": "offset",
  "value": 0,
  "type": "Int"
},
v3 = {
  "operator": "AND",
  "values": ([]/*: any*/)
},
v4 = {
  "kind": "Literal",
  "name": "errorUrl",
  "value": v3,
  "type": "TextFilters"
},
v5 = {
  "kind": "Literal",
  "name": "linkTypeFilter",
  "value": {
    "showExternal": true,
    "showInternal": true
  },
  "type": "LinkTypeFilter"
},
v6 = {
  "kind": "Literal",
  "name": "sourceUrl",
  "value": v3,
  "type": "TextFilters"
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "httpStatus_HttpStatusCategory_Http4xxErrorsTable_Query",
  "id": null,
  "text": "query httpStatus_HttpStatusCategory_Http4xxErrorsTable_Query(\n  $host: String!\n) {\n  project(host: $host) {\n    ...Http4xxErrorsTable_project\n    id\n  }\n}\n\nfragment Http4xxErrorsTable_project on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        countCodesHttp4xxErrors(linkTypeFilter: {showInternal: true, showExternal: true}, errorUrl: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}) {\n          code\n          count\n        }\n        http4xxErrors(offset: 0, limit: 20, codeFilters: [], linkTypeFilter: {showInternal: true, showExternal: true}, errorUrl: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}) {\n          count\n          edges {\n            node {\n              ...Http4xxErrorsRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment Http4xxErrorsRow_issue on Http4xxError {\n  id\n  type\n  severity\n  code\n  internal\n  error_url\n  source_url\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "httpStatus_HttpStatusCategory_Http4xxErrorsTable_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Http4xxErrorsTable_project",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "httpStatus_HttpStatusCategory_Http4xxErrorsTable_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              v2
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countCodesHttp4xxErrors",
                        "storageKey": "countCodesHttp4xxErrors(errorUrl:{\"operator\":\"AND\",\"values\":[]},linkTypeFilter:{\"showExternal\":true,\"showInternal\":true},sourceUrl:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          v4,
                          v5,
                          v6
                        ],
                        "concreteType": "CountCode",
                        "plural": true,
                        "selections": [
                          v7,
                          v8
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "http4xxErrors",
                        "storageKey": "http4xxErrors(codeFilters:[],errorUrl:{\"operator\":\"AND\",\"values\":[]},limit:20,linkTypeFilter:{\"showExternal\":true,\"showInternal\":true},offset:0,sourceUrl:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "codeFilters",
                            "value": [],
                            "type": "[Int]"
                          },
                          v4,
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 20,
                            "type": "Int"
                          },
                          v5,
                          v2,
                          v6
                        ],
                        "concreteType": "Http4xxErrorsConnection",
                        "plural": false,
                        "selections": [
                          v8,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Http4xxErrorsEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Http4xxError",
                                "plural": false,
                                "selections": [
                                  v9,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "type",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "severity",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  v7,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "internal",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "error_url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v9
                    ]
                  }
                ]
              }
            ]
          },
          v9
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2b32b3819a2e8a39bccf8c2b69507596';
module.exports = node;
